import React from 'react';
import { Hero } from '../components/site/Hero';
import { HowItWorks } from '../components/site/HowItWorks';
import { Roles } from '../components/site/Roles';
import { Scenarios } from '../components/site/Scenarios';
import { DecisionRecord } from '../components/site/DecisionRecord';
import { Scrutiny } from '../components/site/Scrutiny';
import { StatusStrip } from '../components/site/StatusStrip';
import { Contact } from '../components/site/Contact';
export function Home() {
  return <>
      <Hero data-id="element-476" data-mp="24gimihek1ipx" />

      {/* How it works, who it's for, what it measures */}
      <HowItWorks data-id="element-477" data-mp="24iv9xa330lad" />
      <Roles data-id="element-478" data-mp="29flrk1ujboxw" />
      <Scenarios data-id="element-479" data-mp="29fvgrn7r9s2j" />

      {/* What you get back */}
      <DecisionRecord data-id="element-480" data-mp="29i7vlri7vmbd" />

      {/* Why it holds up */}
      <Scrutiny data-id="element-481" data-mp="2dirsqv2sipxi" />

      {/* Where we are, and how to start */}
      <StatusStrip data-id="element-482" data-mp="3kvk6gmce9571" />
      <Contact data-id="element-483" data-mp="3kw1zzb7o95b9" />
    </>;
}